import React, { useState } from "react";

import { Button, Flex, Textarea } from "@olist/design-system";

import { FileUpload } from "pages/new-ticket/components/erp-form/components";

interface MessageTextAreaProps {
  isLoading?: boolean;
  onSubmit: (
    message: string,
    files?: { base64: string; filename: string; filetype: string }[]
  ) => void;
}

export function MessageTextArea({ isLoading, onSubmit }: MessageTextAreaProps) {
  const [message, setMessage] = useState("");
  const [files, setFiles] = useState();

  const handleMessageChange = (value: string) => {
    setMessage(value);
  };

  const handleSubmit = () => {
    onSubmit(message, files);
    setMessage("");
  };

  const handleFileChange = (event) => {
    setFiles(event.fileUpload);
  };

  return (
    <Flex flexDirection="column" gap="stack.small">
      <Textarea
        required
        label="Digite sua dúvida de forma mais detalhada possível"
        maxLength={5000}
        onChange={({ target }) => handleMessageChange(target.value)}
        disabled={isLoading}
        value={message}
        rows={6}
      />
      <Flex justifyContent="flex-end" gap="inline.medium" width="100%">
        <FileUpload
          handleFormDataChange={handleFileChange}
          buttonPosition="end"
        />
        <Button
          disabled={!message}
          onClick={handleSubmit}
          isLoading={isLoading}
          style={{ height: "fit-content" }}
        >
          enviar
        </Button>
      </Flex>
    </Flex>
  );
}
